import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';
import { AddToCartService } from '../../_shared/services/add-to-cart.service';

@Component({
  selector: 'app-offer-detail',
  templateUrl: './offer-detail.component.html',
  styleUrls: ['./offer-detail.component.css']
})
export class OfferDetailComponent implements OnInit {
  paramsId: number
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  products: any = [];
  allProducts: any = [];
  sendData: any = {};
  isListEnd: boolean = false
  offset: number = 0
  offsetLoader: boolean = false
  offsetResFetched: boolean = true
  brands: any = []
  brandIds :any=[]
  cart: any = {};
  cartItems: any = [];
  sortType:any ="PriceHigh"
  availableQuantity: number;
  quantityError: boolean = false;
  showLoaderProduct: boolean = false

  constructor(private service: CommonHttpService, private addToCartService: AddToCartService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService) { 
    this.addToCartService.isCartChanged.subscribe(flag => {
      this.cart = JSON.parse(localStorage.getItem('cart'));
      this.cartItems =  (this.cart != null) ? this.cart.EcartItem : [];
      this.updateCart();
    }) 
  }

  ngOnInit() {
    window.scrollTo(0,0);
    this.cart = JSON.parse(localStorage.getItem('cart'));
    this.cartItems =  (this.cart != null) ? this.cart.EcartItem : [];
    this.route.params.subscribe(params => {
      this.paramsId = params['id'];
    });

    this.service.get(this.baseUrl + 'ProductMasterAPI/GetBrandsByOfferId/' + this.paramsId)
    .subscribe(
      data => {
        
        this.brands = data
        console.log(this.brands)
      },
      (error) => {      
    });

    setTimeout(() => {
      this.loadData(1)
    },1);
  }
  
  loadData(flag) {
    this.offsetLoader = false
    flag == 1 ? this.showLoaderProduct = true : this.offsetLoader = true
    if(this.brandIds.length==0)
    {
    this.sendData = {
		  OfferId: this.paramsId, 
		  BrndIds: null,
		  Limit: 12,
		  Offset: this.offset,
		  SortType: this.sortType
     }
    }
    else
    {
      this.sendData = {
        OfferId: this.paramsId, 
        BrndIds: this.brandIds,
        Limit: 12,
        Offset: this.offset,
        SortType: this.sortType
       }
    }
     this.service.create(this.baseUrl + 'ProductAPI/GetProductsByOfferId', this.sendData)
      .subscribe(
        data => {
          console.log(data)
          this.offsetResFetched = true
          this.offsetLoader = false
          this.offset = this.offset + 12
          this.products = data;
          for (var i = 0; i < this.products.length; i++){
          	this.allProducts.push(this.products[i]);
          }
          this.updateCart();
          if (this.products.length == 0) {
             this.isListEnd = true
          }
          this.showLoaderProduct = false
        },
        (error) => {
          this.showLoaderProduct = false
        })
  }

  add_remove_filter= function(checkstatus,itemId){
   
    if(checkstatus.target.checked)
    {
      
      this.brandIds.push(itemId)
      this.offset=0;
      this.isListEnd = false;
      this.allProducts=[]
      this.loadData(1);
    }
    else{
      var pos=this.brandIds.indexOf(itemId);
      this.brandIds.splice(pos,1)
      this.offset=0;
      this.isListEnd = false;
      this.allProducts=[]
      this.loadData(1);
    }
    
  }

  sort_order = function(sortType)
  {
    this.sortType = sortType;
    this.allProducts=[];
    this.offset=0;
    this.isListEnd = false;
    this.loadData(1);
  }

 addToCart(product){
    product.cartQuantity = 1
    this.addToCartService.addToCart(product)
  }

  updateCart(){
    for (var i = 0; i < this.allProducts.length; i++) {
      this.allProducts[i].isAddedToCart = false
    }
    for (var i = 0; i < this.cartItems.length; i++) {
      for (var j = 0; j < this.allProducts.length; j++) {
        if (this.cartItems[i].ProductId == this.allProducts[j].productId) {
          this.allProducts[j].isAddedToCart = true
          this.allProducts[j].cartQuantity = this.cartItems[i].Quantity
        }
      }
    }
  }

  substractquantity(cartQuantity, i){
    this.quantityError = false
    this.allProducts[i].cartQuantity = cartQuantity - 1;
    this.addToCartService.addToCart(this.allProducts[i])
  }

  addQuantity(cartQuantity, i){
    if(cartQuantity + 1 > this.allProducts[i].totalStock){
      this.quantityError = true
      this.availableQuantity = this.allProducts[i].totalStock
      this.allProducts[i].cartQuantity = cartQuantity
    }
    else{
      this.quantityError = false
      this.allProducts[i].cartQuantity = cartQuantity + 1;
    }
    this.addToCartService.addToCart(this.allProducts[i])
  }

  onQuantityChange(cartQuantity, i){
    if(cartQuantity > this.allProducts[i].totalStock){
      this.quantityError = true
      this.availableQuantity = this.allProducts[i].totalStock
      this.allProducts[i].cartQuantity = this.allProducts[i].totalStock;
    }
    else{
      this.quantityError = false
      this.allProducts[i].cartQuantity = cartQuantity;
    }
    this.addToCartService.addToCart(this.allProducts[i])
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
   if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500 && this.allProducts.length > 0) {
        if ( !this.isListEnd && this.offsetResFetched) {
          console.log('a')
          this.offsetResFetched = false
          this.loadData(2)
        }
      }
  }

}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/offer-detail/offer-detail.component.ts